/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { PickersInputLocaleText } from "@mui/x-date-pickers";

export const LOCALE_TEXT: PickersInputLocaleText = {
  previousMonth: "Vorheriger Monat",
  nextMonth: "Nächster Monat",
  openPreviousView: "Vorherige Ansicht öffnen",
  openNextView: "Nächste Ansicht öffnen",
  calendarViewSwitchingButtonAriaLabel: (view) =>
    view === "year" ? "Jahresansicht ist geöffnet, zur Kalenderansicht wechseln" : "Kalenderansicht ist geöffnet, zur Jahresansicht wechseln",
  cancelButtonLabel: "Abbrechen",
  okButtonLabel: "OK",
  datePickerToolbarTitle: "Datum auswählen",
  timePickerToolbarTitle: "Uhrzeit auswählen",
  clockLabelText: (_, formattedTime) => `Uhrzeit auswählen. ${formattedTime ? `Gewählte Uhrzeit ist ${formattedTime}` : "Keine Uhrzeit ausgewählt"}`,
  hoursClockNumberText: (hours) => `${hours} Stunden`,
  minutesClockNumberText: (minutes) => `${minutes} Minuten`,
  openDatePickerDialogue: (formattedDate) => (formattedDate ? `Datum auswählen, gewähltes Datum ist ${formattedDate}` : "Datum auswählen"),
  openTimePickerDialogue: (formattedTime) => (formattedTime ? `Uhrzeit auswählen, gewählte Uhrzeit ist ${formattedTime}` : "Uhrzeit auswählen"),
  fieldYearPlaceholder: () => "jjjj",
  fieldMonthPlaceholder: () => "mm",
  fieldDayPlaceholder: () => "tt",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  year: "Jahr",
  month: "Monat",
  day: "Tag",
  hours: "Stunden",
  minutes: "Minuten",
  empty: "Leer",
};
